import React from "react";
import { connect } from "react-redux";
import { DEFAULT_TEAMPLAE } from "../../constants/canvas";
import {
  deleteTemplate,
  downloadPdf,
  editTemplate,
  saveTemplate,
  setCurrentTemplate,
} from "../../store/actions/canvasActions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const CanvasActions = ({
  canvasWorkingSize,
  currentTemplate,
  canvasObjects,
  token,
  saveTemplate,
  editTemplate,
  deleteTemplate,
  setCurrentTemplate,
  downloadPdf,
  eventId,
}) => {
  const isSaveBtnDisabled =
    !currentTemplate.label || currentTemplate.label === DEFAULT_TEAMPLAE.label;

  const isDeleteBtnDisabled = !currentTemplate.value;

  const handleSave = () => {
    const id = currentTemplate.value;
    const data = {
      ...canvasWorkingSize,
      name: currentTemplate.label,
      framesJson: JSON.stringify(canvasObjects),
      hasFooter: currentTemplate.hasFooter,
    };
    if (id) {
      editTemplate(eventId, data, id, token);
      return;
    }
    saveTemplate(eventId, data, token).then((id) => {
      setCurrentTemplate({ ...currentTemplate, value: id });
    });
  };

  const handlePreview = () => {
    const data = {
      ...canvasWorkingSize,
      name: currentTemplate.label,
      framesJson: JSON.stringify(canvasObjects),
      hasFooter: currentTemplate.hasFooter
    };
    downloadPdf(data, token);
  };

  const handleDelete = () => {
    MySwal.fire({
      title: "Are you sure that you want to delete this template?",
      text: "It's impossible to take step back then",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      confirmButtonText: "Delete",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        deleteTemplate(eventId, currentTemplate.value, token);
      }
    });
  };

  return (
    <>
      <button
        className="btn-primary"
        onClick={handlePreview}
        disabled={isSaveBtnDisabled}
      >
        Download Pdf
      </button>
      <button
        className="btn-red-outline"
        onClick={handleDelete}
        disabled={isDeleteBtnDisabled}
      >
        Delete
      </button>
      <button
        className="btn-primary"
        onClick={handleSave}
        disabled={isSaveBtnDisabled}
      >
        Save
      </button>
    </>
  );
};

const mapStateToProps = ({ canvas, auth, events: { currentEvent }, }) => ({
  canvasWorkingSize: canvas.canvasWorkingSize,
  currentTemplate: canvas.currentTemplate,
  canvasObjects: canvas.canvasObjects,
  token: auth.user.token,
  eventId: currentEvent.id,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentTemplate: (template) => dispatch(setCurrentTemplate(template)),
  saveTemplate: (eventId, data, userToken) => dispatch(saveTemplate(eventId, data, userToken)),
  editTemplate: (eventId, data, id, userToken) =>
    dispatch(editTemplate(eventId, data, id, userToken)),
  deleteTemplate: (eventId, id, userToken) => dispatch(deleteTemplate(eventId, id, userToken)),
  downloadPdf: (data, token) => dispatch(downloadPdf(data, token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CanvasActions);
